import type { WorkspaceData } from "@/shared/contracts";
import { type ReactNode, createContext, useContext } from "react";

const WorkspaceContext = createContext<WorkspaceData | null>(null);

export function WorkspaceProvider({
  value,
  children,
}: { value: WorkspaceData; children: ReactNode }) {
  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export function useWorkspace() {
  const workspace = useContext(WorkspaceContext);
  if (!workspace) throw new Error("useWorkspace deve essere usato dentro WorkspaceProvider");
  return workspace;
}
